<p-dialog
  [ngClass]="{ 'assistant-minimized': minimized }"
  #chatDialog
  (visibleChange)="onHideChat()"
  [showHeader]="true"
  [focusOnShow]="true"
  [resizable]="true"
  [draggable]="true"
  [maximizable]="!minimized"
  [visible]="floatingAssistantChatService.visible"
  [closable]="true"
  position="bottomright"
  [style]="{ width: minimized ? '70px' : '550px', height: minimized ? '50px' : '900px' }"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <!-- Icons Container (Right-Aligned) -->
      <div class="header-icons">
        <!-- Minimize Button (Only when not minimized and not maximized) -->
        @if (!minimized && !isDialogMaximized) {
          <button
            class="header-button"
            type="button"
            (click)="toggleMinimize()"
          >
            <i class="pi pi-window-minimize"></i>
          </button>
        }

        <!-- Restore Button (Only when minimized) -->
        @if (minimized) {
          <button
            class="header-button"
            type="button"
            (click)="restoreAssistant()"
          >
            <i class="pi pi-window-maximize"></i>
          </button>
        }
      </div>
    </div>
  </ng-template>

  <!-- Assistant Chat Content (Only show when not minimized) -->
  <ng-container>
    @if (!minimized && assistantData) {
      <app-assistant-chat [assistantData]="assistantData" />
    }
  </ng-container>
</p-dialog>
